// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressBar_nt_R5 {
    background-color: transparent;
    position: absolute;
    height: 2px;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
  }

  .progressThumb_NxB6A {
    position: absolute;
    top: 0;
    bottom: 0;
    left:0;
    right: 100%;
    transition: right 0.3s linear;
    background-color: var(--color-brand400);
  }

  .progressThumb_NxB6A:after {
    content: "";
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
    background-image: linear-gradient(
      -45deg,
      var(--color-brand200) 25%,
      transparent 25%,
      transparent 50%,
      var(--color-brand200) 50%,
      var(--color-brand200) 75%,
      transparent 75%,
      transparent
    );
    z-index: 1;
    background-size: 50px 50px;
    animation: move__1_Wo 2s linear infinite;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    overflow: hidden;
  }

  .meter_uvpqq > span:after {
    animation: move__1_Wo 2s linear infinite;
  }

  @keyframes move__1_Wo {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 50px 50px;
    }
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/views/ProgressBar.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,OAAO;IACP,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,MAAM;IACN,WAAW;IACX,6BAA6B;IAC7B,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM,EAAE,OAAO,EAAE,SAAS,EAAE,QAAQ;IACpC;;;;;;;;;KASC;IACD,UAAU;IACV,0BAA0B;IAC1B,wCAAkC;IAClC,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,wCAAkC;EACpC;;EAEA;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,8BAA8B;IAChC;EACF","sourcesContent":[".progressBar {\n    background-color: transparent;\n    position: absolute;\n    height: 2px;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    z-index: 1;\n  }\n\n  .progressThumb {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left:0;\n    right: 100%;\n    transition: right 0.3s linear;\n    background-color: var(--color-brand400);\n  }\n\n  .progressThumb:after {\n    content: \"\";\n    position: absolute;\n    top: 0; left: 0; bottom: 0; right: 0;\n    background-image: linear-gradient(\n      -45deg,\n      var(--color-brand200) 25%,\n      transparent 25%,\n      transparent 50%,\n      var(--color-brand200) 50%,\n      var(--color-brand200) 75%,\n      transparent 75%,\n      transparent\n    );\n    z-index: 1;\n    background-size: 50px 50px;\n    animation: move 2s linear infinite;\n    border-top-right-radius: 8px;\n    border-bottom-right-radius: 8px;\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    overflow: hidden;\n  }\n\n  .meter > span:after {\n    animation: move 2s linear infinite;\n  }\n\n  @keyframes move {\n    0% {\n      background-position: 0 0;\n    }\n    100% {\n      background-position: 50px 50px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressBar": `progressBar_nt_R5`,
	"progressThumb": `progressThumb_NxB6A`,
	"move": `move__1_Wo`,
	"meter": `meter_uvpqq`
};
export default ___CSS_LOADER_EXPORT___;
